import { z } from 'zod';

const phoneRegex = /^[6-9]\d{9}$/;

export const profileSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters').max(60, 'Name too long'),
  email: z.string().email('Enter a valid email address'),
  phone: z.string().regex(phoneRegex, 'Enter a valid 10-digit Indian mobile number'),
});
export type ProfileFormValues = z.infer<typeof profileSchema>;
